import { render, staticRenderFns } from "./ListRates.vue?vue&type=template&id=8e982b80&scoped=true&"
import script from "./ListRates.vue?vue&type=script&lang=js&"
export * from "./ListRates.vue?vue&type=script&lang=js&"
import style0 from "./ListRates.vue?vue&type=style&index=0&id=8e982b80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e982b80",
  null
  
)

export default component.exports